import React from 'react';

import SpinnerIsoType from 'elitegrad-common/src/components/SpinnerIsoType';

const AuthCheckingSession: React.FC = () => {
  return <SpinnerIsoType fullPage text="" />;
};

export default AuthCheckingSession;
